/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection06FoiChanged, m11ReportSection06ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection06Foi, selectM11ReportSection06Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialInterventionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section06State, setAlertModalState, setStartingSection06State) => {

    let changesStates = {
        section06State: section06State
    };
    let response = await saveM11Changes(apiToken, 25, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection06Resource) {
            dispatch(m11ReportSection06ResourceChanged(response.m11ReportSection06Resource));
        }
        setStartingSection06State(JSON.parse(JSON.stringify(section06State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step025TrialInterventionPart5 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection06Foi = useSelector(selectM11ReportSection06Foi);
    const m11ReportSection06Resource = useSelector(selectM11ReportSection06Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section06State, setSection06State] = useState({
        "section68Status": "empty", "section68Xhtml": "",
        "section69Status": "empty", "section69Xhtml": "",
        "section691Status": "empty", "section691Xhtml": "",
        "section692Status": "empty", "section692Xhtml": "",
        "section693Status": "empty", "section693Xhtml": "",
        "section6101Status": "empty", "section6101Xhtml": "",
        "section6102Status": "empty", "section6102Xhtml": "",
        "section610Status": "empty", "section610Xhtml": ""
    });
    const [startingSection06State, setStartingSection06State] = useState({
        "section68Status": "empty", "section68Xhtml": "",
        "section69Status": "empty", "section69Xhtml": "",
        "section691Status": "empty", "section691Xhtml": "",
        "section692Status": "empty", "section692Xhtml": "",
        "section693Status": "empty", "section693Xhtml": "",
        "section6101Status": "empty", "section6101Xhtml": "",
        "section6102Status": "empty", "section6102Xhtml": "",
        "section610Status": "empty", "section610Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section06State, startingSection06State)),
        async saveAllChanges() {
            await saveTrialInterventionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section06State, setAlertModalState, setStartingSection06State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section68Status": "empty", "section68Xhtml": "",
                "section69Status": "empty", "section69Xhtml": "",
                "section691Status": "empty", "section691Xhtml": "",
                "section692Status": "empty", "section692Xhtml": "",
                "section693Status": "empty", "section693Xhtml": "",
                "section6101Status": "empty", "section6101Xhtml": "",
                "section6102Status": "empty", "section6102Xhtml": "",
                "section610Status": "empty", "section610Xhtml": "",
                "loaded": true
            };
            setSection06State(startingData);
            setStartingSection06State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[6]?.entry?.length) {
                let m11ReportSection006Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
                if (m11ReportSection006Foi && !isNaN(m11ReportSection006Foi) && m11ReportSection006Foi !== m11ReportSection06Foi) {
                    dispatch(m11ReportSection06FoiChanged(m11ReportSection006Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
            loadResource(m11ReportSection06Foi, "M11ReportSection06", apiToken, dispatch);
        }
    }, [m11ReportSection06Foi]);

    useEffect(() => {
        if (m11ReportSection06Resource && Object.keys(m11ReportSection06Resource).length > 0) {
            let startingData = {
                "section68Status": "empty", "section68Xhtml": "",
                "section69Status": "empty", "section69Xhtml": "",
                "section691Status": "empty", "section691Xhtml": "",
                "section692Status": "empty", "section692Xhtml": "",
                "section693Status": "empty", "section693Xhtml": "",
                "section6101Status": "empty", "section6101Xhtml": "",
                "section6102Status": "empty", "section6102Xhtml": "",
                "section610Status": "empty", "section610Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection06Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection06Resource.section[0].section[7]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[7].text.status !== "empty") {
                    startingData.section68Status = m11ReportSection06Resource.section[0].section[7].text.status;
                    startingData.section68Xhtml = m11ReportSection06Resource.section[0].section[7].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[8]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[8].text.status !== "empty") {
                    startingData.section69Status = m11ReportSection06Resource.section[0].section[8].text.status;
                    startingData.section69Xhtml = m11ReportSection06Resource.section[0].section[8].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[8]?.section?.length > 0) {
                    if (m11ReportSection06Resource.section[0].section[8].section[0]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[8].section[0].text.status !== "empty") {
                        startingData.section691Status = m11ReportSection06Resource.section[0].section[8].section[0].text.status;
                        startingData.section691Xhtml = m11ReportSection06Resource.section[0].section[8].section[0].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[8].section?.[1]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[8].section[1].text.status !== "empty") {
                        startingData.section692Status = m11ReportSection06Resource.section[0].section[8].section[1].text.status;
                        startingData.section692Xhtml = m11ReportSection06Resource.section[0].section[8].section[1].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[8].section?.[2]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[8].section[2].text.status !== "empty") {
                        startingData.section693Status = m11ReportSection06Resource.section[0].section[8].section[2].text.status;
                        startingData.section693Xhtml = m11ReportSection06Resource.section[0].section[8].section[2].text.div;
                    }
                }
                if (m11ReportSection06Resource.section[0].section[9]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[9].text.status !== "empty") {
                    startingData.section610Status = m11ReportSection06Resource.section[0].section[9].text.status;
                    startingData.section610Xhtml = m11ReportSection06Resource.section[0].section[9].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[9]?.section?.length > 0) {
                    if (m11ReportSection06Resource.section[0].section[9].section[0]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[9].section[0].text.status !== "empty") {
                        startingData.section6101Status = m11ReportSection06Resource.section[0].section[9].section[0].text.status;
                        startingData.section6101Xhtml = m11ReportSection06Resource.section[0].section[9].section[0].text.div;
                    }
                    if (m11ReportSection06Resource.section[0].section[9].section[1]?.text?.div &&
                        m11ReportSection06Resource.section[0].section[9].section[1].text.status !== "empty") {
                        startingData.section6102Status = m11ReportSection06Resource.section[0].section[9].section[1].text.status;
                        startingData.section6102Xhtml = m11ReportSection06Resource.section[0].section[9].section[1].text.div;
                    }
                }
                setSection06State(startingData);
                setStartingSection06State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection06Resource]);

    return <div>
        <h3>Complete Section 6 Trial Intervention and Concomitant Therapy</h3>
        {!(m11ReportSection06Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 25 (Complete Section 6 Trial Intervention and Concomitant Therapy) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section06State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.8 Investigational Trial Intervention Adherence.</h4>
                    <TextDivEntry elementName="section68Xhtml"
                        startingValue={section06State.section68Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.9 Description of Noninvestigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section69Xhtml"
                        startingValue={section06State.section69Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.9.1 Background Trial Intervention.</h4>
                    <TextDivEntry elementName="section691Xhtml"
                        startingValue={section06State.section691Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.9.2 Rescue Therapy.</h4>
                    <TextDivEntry elementName="section692Xhtml"
                        startingValue={section06State.section692Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.9.3 Other Noninvestigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section693Xhtml"
                        startingValue={section06State.section693Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.10 Concomitant Therapy.</h4>
                    <TextDivEntry elementName="section610Xhtml"
                        startingValue={section06State.section610Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.10.1 Prohibited Concomitant Therapy.</h4>
                    <TextDivEntry elementName="section6101Xhtml"
                        startingValue={section06State.section6101Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>If applicable, enter data for Section 6.10.2 Permitted Concomitant Therapy.</h4>
                    <TextDivEntry elementName="section6102Xhtml"
                        startingValue={section06State.section6102Xhtml}
                        setResourceState={setSection06State} />
                </>}
            </>
        }
    </div >
});

const M11Step025TrialInterventionPart5HelperText = <div>
    <h3>Complete Section 6 Trial Intervention and Concomitant Therapy</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 6.8 Investigational Trial Intervention Adherence.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the measures to monitor and document participants’ adherence to investigational trial intervention (e.g., trial intervention accountability records, paper or electronic diaries, or investigational trial intervention concentration measurements).</p>
            <p>List what documents are mandatory to complete (e.g., participant drug log) and identify which records will be used as the source records for documenting investigational trial intervention adherence.</p>
        </div>
        <p>Enter data for Section 6.9 Description of Noninvestigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>As stated in Section 6 Trial Intervention and Concomitant Therapy, noninvestigational interventions are pre-specified products used in the trial but are not part of trial objectives and hence, are not investigational trial interventions.</p>
        </div>
        <p>If applicable, enter data for Section 6.9.1 Background Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe any background intervention(s), including administration and any conditions for use.</p>
        </div>
        <p>If applicable, enter data for Section 6.9.2 Rescue Therapy.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>List all permitted rescue medications, treatments, and/or procedures, including any relevant instructions on administration and any conditions of use.</p>
            <p>If administration of rescue therapy leads to the temporary or permanent discontinuation of trial intervention, refer to Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial.</p>
        </div>
        <p>If applicable, enter data for Section 6.9.3 Other Noninvestigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe the use of any other noninvestigational trial intervention (e.g., challenge agents or diagnostics). </p>
        </div>
        <p>Enter data for Section 6.10 Concomitant Therapy.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Specify the concomitant medications, supplements, complementary and alternative therapies, treatments, and/or procedures that are prohibited or permitted during the trial and include details about when the information will be collected (e.g., during screening, at each visit).</p>
            <p>When appropriate to separate the content, the below subheadings may be used.</p>
        </div>
        <p>If applicable, enter data for Section 6.10.1 Prohibited Concomitant Therapy.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe any prohibited concomitant therapy.</p>
        </div>
        <p>If applicable, enter data for Section 6.10.2 Permitted Concomitant Therapy.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe any permitted concomitant therapy.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step025TrialInterventionPart5ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 25, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 25 (Complete Section 6 Trial Intervention and Concomitant Therapy) {validationCheckState.step25numberOfChecks} issues checked. {validationCheckState.step25numberPassed} passed. {validationCheckState.step25numberFailed} failed.</h4>
        <p>Section 6.8 heading is 'Investigational Trial Intervention Adherence': {validationCheckState.resultChecksection68Heading}</p>
        <p>Section 6.8 Investigational Trial Intervention Adherence has content: {validationCheckState.resultCheckSection68Content}</p>
        <p>Section 6.9 heading is 'Description of Noninvestigational Trial Intervention': {validationCheckState.resultChecksection69Heading}</p>
        <p>Section 6.9 Description of Noninvestigational Trial Intervention has content: {validationCheckState.resultCheckSection69Content}</p>
        <p>If present, Section 6.9.1 heading is 'Background Trial Intervention': {validationCheckState.resultCheckSection691Heading}</p>
        <p>If present, Section 6.9.1 Background Trial Intervention has content: {validationCheckState.resultCheckSection691Content}</p>
        <p>If present, Section 6.9.2 heading is 'Rescue Therapy': {validationCheckState.resultCheckSection692Heading}</p>
        <p>If present, Section 6.9.2 Rescue Therapy has content: {validationCheckState.resultCheckSection692Content}</p>
        <p>If present, Section 6.9.3 heading is 'Other Noninvestigational Trial Intervention' or 'Other Noninvestigational Intervention': {validationCheckState.resultCheckSection693Heading}</p>
        <p>If present, Section 6.9.3 Other Noninvestigational Trial Intervention has content: {validationCheckState.resultCheckSection693Content}</p>
        <p>Section 6.10 heading is 'Concomitant Therapy': {validationCheckState.resultChecksection610Heading}</p>
        <p>Section 6.10 Concomitant Therapy has content: {validationCheckState.resultCheckSection610Content}</p>
        <p>If present, Section 6.10.1 heading is 'Prohibited Concomitant Therapy': {validationCheckState.resultChecksection6101Heading}</p>
        <p>If present, Section 6.10.1 Prohibited Concomitant Therapy has content: {validationCheckState.resultCheckSection6101Content}</p>
        <p>If present, Section 6.10.2 heading is 'Permitted Concomitant Therapy': {validationCheckState.resultChecksection6102Heading}</p>
        <p>If present, Section 6.10.2 Permitted Concomitant Therapy has content: {validationCheckState.resultCheckSection6102Content}</p>
      </div>}  </div>
}

export default M11Step025TrialInterventionPart5;
export { M11Step025TrialInterventionPart5HelperText, M11Step025TrialInterventionPart5ValidationCheck };